export default __webpack_public_path__ + "assets/images/7215aed9e2172846a1d1aaa81881bc77.png";